<template>
  <div class="footer">
    <div class="catalog">
      <div class="item">
        <div class="title">首页</div>
        <ul>
          <li @click="goProduct('1', '宏观高频模拟和预测库')">宏观高频模拟和预测库</li>
          <li @click="goProduct('1', '行业高频模拟和预测库')">行业高频模拟和预测库</li>
          <li @click="goProduct('1', '宏观和行业全口径数据库')">宏观和行业全口径数据库</li>
          <!-- <li @click="goProduct('2', '申万行业高频模拟和预测库')">申万行业高频模拟和预测库</li> -->
          <li @click="goProduct('2', '产品概述')">区域经济运行感知预测预警库</li>
          <li @click="goProduct('3', '钢铁行业预测预警库')">钢铁行业预测预警库</li>
          <li @click="goProduct('6', '产品概述')">绿色发展核算分析库</li>
        </ul>
      </div>
      <div class="item">
        <div class="title">数据产品</div>
        <ul>
          <li @click="goLogin">宏观经济</li>
          <li @click="goLogin">区域数字政府</li>
          <li @click="goLogin">产业链</li>
          <li @click="goLogin">企预测</li>
          <li @click="goLogin">资本市场</li>
          <li @click="goLogin">双碳&绿色核算</li>
        </ul>
      </div>
      <div class="item">
        <div class="title">研究报告</div>
        <ul>
          <li @click="goReport('macro1')">腾景宏观高频研报</li>
          <li @click="goReport('macro2')">腾景宏观全口径研报</li>
          <!-- <li @click="goReport('SW')">腾景申万行业研报</li>
          <li @click="goReport('Bulk')">腾景大宗商品预测预警研报</li> -->
          <li @click="goReport('Financial')">腾景钢铁行业预测预警研报</li>
        </ul>
      </div>
      <div class="item">
        <div class="title">企预测</div>
        <ul>
          <li @click="goLogin">企预测</li>
        </ul>
      </div>
      <div class="item">
        <div class="title">联系我们</div>
        <ul>
          <li class="code" @click="toggle = true">
            微信公众号
            <img
              class="swing-in-right-fwd"
              v-if="toggle"
              src="@/assets/img/contact/code1.png"
              alt
            />
          </li>
          <li class="code" @click="toggle = false">
            微信客服
            <img
              class="swing-in-right-fwd"
              v-if="!toggle"
              src="@/assets/img/contact/code2.png"
              alt
            />
          </li>
          <li>电话:15210925572</li>
          <li>邮箱:TengjingAI@tjresearch.com</li>
        </ul>
      </div>
    </div>
    <div class="decla">
      <div>版权声明©腾景研究院2019-2020 京公网安备 11010102003465号 | 京ICP备18046501号-1</div>
      <div>为了给您更好的体验，推荐使用Chrome浏览器</div>
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixins.js";
export default {
  mixins: [mixin],
  data() {
    return {
      toggle: true
    };
  },
  methods: {
    goLogin() {
      this.goMacro();
    },
    goProduct(val, name) {
      this.$router.push({
        path: "/product",
        query: {
          system: val,
          id: name
        }
      });
    },
    goReport(val) {
      this.$router.push({
        path: "/report",
        query: {
          system: val,
          flag: "footer"
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.footer {
  background: #252525;
  padding: 20px 22%;
  color: #999999;
  font-size: 12px;
  z-index: 20;
  height: 340px;
  box-sizing: border-box;
  .catalog {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #525252;
    padding-bottom: 4px;
    margin-bottom: 4px;
    .item {
      .title {
        color: #fff;
        font-size: 18px;
        margin-bottom: 12px;
      }
      ul {
        list-style: none;
        padding: 0;
        li {
          padding: 4px 0;
          cursor: pointer;
        }
        li:hover {
          color: #dd6643;
          transition: all 0.3;
        }
        .code {
          display: flex;
          flex-direction: column;
          img {
            height: 100px;
            width: 100px;
            padding: 8px 0;
          }
        }
      }
    }
  }
  .decla {
    text-align: center;
  }
  .swing-in-right-fwd {
    animation: swing-in-right-fwd 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)
      both;
  }
  @keyframes swing-in-right-fwd {
    0% {
      transform: rotateY(-100deg);
      transform-origin: right;
      opacity: 0;
    }
    100% {
      transform: rotateY(0);
      transform-origin: right;
      opacity: 1;
    }
  }
}
</style>